export var PictureTag;
(function (PictureTag) {
    PictureTag["Favorite"] = "favorite";
    PictureTag["Blue"] = "blue";
    PictureTag["Green"] = "green";
    PictureTag["Yellow"] = "yellow";
    PictureTag["Red"] = "red";
    PictureTag["Violet"] = "violet";
    PictureTag["Grey"] = "grey";
    PictureTag["SubjectFavorite"] = "subjectfav";
    PictureTag["Spare"] = "spare";
    PictureTag["Hidden"] = "hidden";
    PictureTag["GroupPicture"] = "group_picture";
    PictureTag["MiniGroupPicture"] = "mini_group_picture";
    PictureTag["IndividualPicture"] = "individual_picture";
})(PictureTag || (PictureTag = {}));
